import React from 'react';
import { DataRowRecord, DataColumn } from '../types';
import BaseCell from './BaseCell';

type DataTableColType<T extends DataRowRecord> = {
  rows: T[];
  column: DataColumn<T>;
};

const DataTableCol = <T extends DataRowRecord>({
  column,
}: DataTableColType<T>): JSX.Element => {
  return (
    <BaseCell
      button={column.button}
      center={column.center}
      width={column.width}
      maxWidth={column.maxWidth}
      minWidth={column.minWidth}
      right={column.right}
      dataTag='allowRowEvents'
      id={`cell-${column.id || 1}-header}`}
    >
      <div className='overflow-hidden font-semibold text-gray tracking-tight uppercase whitespace-nowrap overflow-ellipsis'>
        {column.name}
      </div>
    </BaseCell>
  );
};

export default DataTableCol;
